<template>
      <div class="container">
          <div class="rcv__heading-v1">
               <h1>{{ballotData.errorHeading}}</h1>
          </div>
          <div class="rcv__start-screen-row">
              <div class="rcv__start-screen-left" v-if="ballotData.image">
                <img :src="ballotData.image" :alt="ballotData.altText" width="800" height="379">
              </div>
              <div class="rcv__start-screen-right">
                  <div class="rcv__text-bubble"> 
                      <div class="rcv__text-bubble-text" v-html="ballotData.textMessage">
                      </div>
                      <span class="rcv__text-bubble-arrow"><img src="../../public/assets/rcv-images/down-arrow.svg" alt=""></span>
                  </div>
              </div>
          </div>
      </div>
</template>
<script>
export default {
  name: "ErrorPageComponent",
  props: {
    ballotData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {};
  },

  computed: {

  },

  methods: {

  },
  mounted(){

  }
};
</script>


// WEBPACK FOOTER //
// src/components/ErrorPageComponent.vue